<video [src]="src" controls></video>